var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccommodations = function SvgAccommodations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.696
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.606 17.652a.348.348 0 0 1-.348.348H3.713a.348.348 0 0 1-.348-.348V6.87h13.241v10.782zM3.365 11.043h13.242M2 6.87h16M8.244 3.391h3.484M2.668 6.87l1.646-3.287a.348.348 0 0 1 .312-.192h1.527m7.665 0h1.529c.131 0 .251.074.31.192l1.66 3.287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.818 8.261h1.394v1.391h-1.394zm-2.787 0h1.394v1.391h-1.394zm-3.484 0h1.394v1.391H7.547zm-2.788 0h1.394v1.391H4.759zM11.728 18v-3.13a.348.348 0 0 0-.349-.348H8.592a.348.348 0 0 0-.349.348V18m4.879-5.565h2.09v2.087h-2.09zm-8.363 0H6.85v2.087H4.759zm9.059-10.087A.348.348 0 0 0 13.47 2h-1.394a.348.348 0 0 0-.348.348v3.13h2.09v-3.13zm-5.574 0A.348.348 0 0 0 7.895 2H6.501a.348.348 0 0 0-.348.348v3.13h2.09v-3.13z"
  }))));
};
export default SvgAccommodations;